import {FloorActions, FloorPlanActionTypes} from '../actions/floor-plan.actions';
import {Floor} from '../models/floor';
import {ErrorPayload} from '../models/general';

export interface State {
  entities: { [floorId: string]: Floor };
  isGetFloorsLoaded: boolean;
  getFloorsError: string | null;
  isPostFloorLoaded: boolean;
  postFloorError: string | null;
  isPostFloorPlanImageLoading: boolean;
  isPostFloorPlanImageLoaded: boolean;
  postFloorPlanImageError: string | null;
  isPutFloorDevicesLoading: boolean;
  isPutFloorDevicesLoaded: boolean;
  putFloorDevicesError: string | null;
  isDeleteFloorLoading: boolean;
  isDeleteFloorLoaded: boolean;
  deleteFloorError: string | null;
}

export const initialState: State = {
  entities: {},
  isGetFloorsLoaded: false,
  getFloorsError: null,
  isPostFloorLoaded: false,
  postFloorError: null,
  isPostFloorPlanImageLoading: false,
  isPostFloorPlanImageLoaded: false,
  postFloorPlanImageError: null,
  isPutFloorDevicesLoading: false,
  isPutFloorDevicesLoaded: false,
  putFloorDevicesError: null,
  isDeleteFloorLoading: false,
  isDeleteFloorLoaded: false,
  deleteFloorError: null
};

export function reducer(state = initialState, action: FloorActions): State {
  switch (action.type) {
    case FloorPlanActionTypes.GetOrganizationFloors: {
      return {
        ...state,
        isGetFloorsLoaded: false,
        getFloorsError: null
      }
    }

    case FloorPlanActionTypes.GetOrganizationFloorsComplete: {
      const floorList: Floor[] = action.payload;
      const entities: { [id: string]: Floor } = floorList.reduce((acc: { [floorId: string]: Floor }, floor: Floor) => {
        return {...acc, [floor.id]: floor}
      }, {});

      return {
        ...state,
        entities,
        isGetFloorsLoaded: true
      }
    }

    case FloorPlanActionTypes.GetOrganizationFloorsError: {
      const errorPayload: ErrorPayload = action.payload;

      return {
        ...state,
        isGetFloorsLoaded: true,
        getFloorsError: errorPayload.errorMessage
      }
    }

    case FloorPlanActionTypes.PostFloor: {
      return {
        ...state,
        isPostFloorLoaded: false,
        postFloorError: null
      };
    }

    case FloorPlanActionTypes.PostFloorComplete: {
      const floor: Floor = action.payload;
      const entities: { [id: string]: Floor } = {...state.entities, [floor.id]: floor};

      return {
        ...state,
        entities,
        isPostFloorLoaded: true
      };
    }

    case FloorPlanActionTypes.PostFloorError: {
      const errorPayload: ErrorPayload = action.payload;

      return {
        ...state,
        isPostFloorLoaded: true,
        postFloorError: errorPayload.errorMessage
      };
    }

    case FloorPlanActionTypes.DeleteFloor: {
      return {
        ...state,
        isDeleteFloorLoading: true,
        isDeleteFloorLoaded: false,
        postFloorError: null
      };
    }

    case FloorPlanActionTypes.DeleteFloorComplete: {
      return {
        ...state,
        isDeleteFloorLoading: false,
        isDeleteFloorLoaded: true
      };
    }

    case FloorPlanActionTypes.DeleteFloorError: {
      const errorPayload: ErrorPayload = action.payload;
      return {
        ...state,
        isDeleteFloorLoading: false,
        isDeleteFloorLoaded: true,
        deleteFloorError: errorPayload.errorMessage
      };
    }

    case FloorPlanActionTypes.PostFloorPlanImage: {
      return {
        ...state,
        isPostFloorPlanImageLoading: true,
        isPostFloorPlanImageLoaded: false,
        postFloorPlanImageError: null
      };
    }

    case FloorPlanActionTypes.PostFloorPlanImageComplete: {
      const payload = action.payload;

      return {
        ...state,
        isPostFloorPlanImageLoading: false,
        isPostFloorPlanImageLoaded: true
      };
    }

    case FloorPlanActionTypes.PostFloorPlanImageError: {
      const errorPayload: ErrorPayload = action.payload;

      return {
        ...state,
        isPostFloorPlanImageLoading: false,
        isPostFloorPlanImageLoaded: true,
        postFloorPlanImageError: errorPayload.errorMessage
      }
    }

    case FloorPlanActionTypes.PutFloorDevices: {
      return {
        ...state,
        isPutFloorDevicesLoading: true,
        isPutFloorDevicesLoaded: false,
        putFloorDevicesError: null
      };
    }

    case FloorPlanActionTypes.PutFloorDevicesComplete: {
      const payload = action.payload;

      return {
        ...state,
        isPutFloorDevicesLoading: false,
        isPutFloorDevicesLoaded: true
      };
    }

    case FloorPlanActionTypes.PutFloorDevicesError: {
      const errorPayload: ErrorPayload = action.payload;

      return {
        ...state,
        isPutFloorDevicesLoading: false,
        isPutFloorDevicesLoaded: true,
        putFloorDevicesError: errorPayload.errorMessage
      }
    }

    default:
      return state;
  }
}

export const floorEntities = (state: State) => state.entities;
export const isGetFloorsLoaded = (state: State) => state.isGetFloorsLoaded;
export const getFloorsError = (state: State) => state.getFloorsError;
export const isPostFloorLoaded = (state: State) => state.isPostFloorLoaded;
export const postFloorError = (state: State) => state.postFloorError;
export const isPostFloorPlanImageLoading = (state: State) => state.isPostFloorPlanImageLoading;
export const isPostFloorPlanImageLoaded = (state: State) => state.isPostFloorPlanImageLoaded;
export const postFloorPlanImageError = (state: State) => state.postFloorPlanImageError;
export const isPutFloorDevicesLoading = (state: State) => state.isPutFloorDevicesLoading;
export const isPutFloorDevicesLoaded = (state: State) => state.isPutFloorDevicesLoaded;
export const putFloorDevicesError = (state: State) => state.putFloorDevicesError;
export const isDeleteFloorLoading = (state: State) => state.isDeleteFloorLoading;
export const isDeleteFloorLoaded = (state: State) => state.isDeleteFloorLoaded;
export const deleteFloorError = (state: State) => state.deleteFloorError;
